export default {
  quantityByProduct: state => product =>
    state.items
      .map(basketProduct => {
        return product.articleNumber === basketProduct.articleNumber
          ? basketProduct.quantity
          : 0;
      })
      .reduce((total, num) => total + num, 0),
  items: state => state.items,
  size: state => {
    return state.items
      .map(product => product.quantity)
      .reduce((total, num) => total + num, 0);
  }
};
